import SidebarHistoricoCampanhas from '../SidebarHistoricoCampanhas'
import { useCampaignSidebar } from '../../contexts/CampaignSidebarContext/useCampaignSidebar'

const GlobalCampaignSidebar = () => {
  const {
    isExpanded,
    setExpanded,
    campaigns,
    selectedCampaignId,
    isLoadingCampaigns,
    hasMoreCampaigns,
    loadMoreCampaigns,
    searchCampaigns,
    selectCampaign,
    requestCreateCampaign,
    artesCriadas,
    limiteArtes,
    availableArts,
  } = useCampaignSidebar()

  return (
    <SidebarHistoricoCampanhas
      campaings={campaigns}
      onLoadMore={loadMoreCampaigns}
      hasMore={hasMoreCampaigns}
      isLoading={isLoadingCampaigns}
      onSearch={searchCampaigns}
      onSelect={selectCampaign}
      onCreate={requestCreateCampaign}
      selecionada={selectedCampaignId}
      isExpanded={isExpanded}
      onToggleExpanded={setExpanded}
      artesCriadas={artesCriadas}
      limiteArtes={limiteArtes}
      availableArts={availableArts}
    />
  )
}

export default GlobalCampaignSidebar
